import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Box from '@mui/material/Box';

import AppHeader from '../../components/app-header';
import AppFooter from '../../components/app-footer';
import Alert from '../../components/shared/Alert';
import Input from '../../components/shared/Input';
import Button from '../../components/shared/Button';
import TermsModal from '../../components/app-footer/TermsModal';

import { withFirebase } from '../../firebase';
import { setCurrentUser } from '../../actions/userActions';

import './sign-up-page.scss';

const SignUpPage = ({ firebase, setUser, history }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordVerification, setPasswordVerification] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [warning, setWarning] = useState(false);
  const [open, setOpen] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (
      !email ||
      !password ||
      !passwordVerification ||
      !firstName ||
      !lastName
    ) {
      setWarning(true);
      return;
    }

    if (password !== passwordVerification) {
      setError('Password does not match');
      return;
    }

    setOpen(true);
  };

  const onSignUp = () => {
    setOpen(false);
    setError(null);
    setLoading(true);

    firebase
      .doCreateUserWithEmailAndPassword(email, password, {
        firstName,
        lastName,
      })
      .then((user) => {
        setUser(user);
        history.push('/dashboard');
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  const year = new Date().getFullYear();

  return (
    <Box className="sign-up-page">
      <AppHeader />

      <Box className="sign-up-form-container">
        <h3>Sign Up</h3>

        <form onSubmit={handleSubmit}>
          <Box sx={{ mt: 1}} className="sign-up-form">
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ mr: 1, flex: 1 }}>
                <Input
                  label="First Name"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                    setError(null);
                  }}
                />
              </Box>
              <Box sx={{ ml: 1, flex: 1 }}>
                <Input
                  label="Last Name"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                    setError(null);
                  }}
                />
              </Box>
            </Box>

            <Box sx={{ mt: 1 }}>
              <Input
                label="Email"
                type="email"
                fullWidth
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(null);
                }}
              />
            </Box>

            <Box sx={{ mt: 1 }}>
              <Input
                type="password"
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Box>

            <Box sx={{ mt: 1 }}>
              <Input
                type="password"
                label="Confirm Password"
                value={passwordVerification}
                onChange={(e) => setPasswordVerification(e.target.value)}
              />
            </Box>
          </Box>

          <Box className="actions">
            <Button
              type="submit"
              disabled={loading}
              loading={loading}
              text="Sign Up"
            />
          </Box>
        </form>
      </Box>

      <Alert
        variant="error"
        message={error}
        open={!!error}
        onClose={() => setError(null)}
      />

      <Alert
        variant="warning"
        message="All fields are required"
        open={warning}
        onClose={() => setWarning(false)}
      />

      <TermsModal
        open={open}
        year={year}
        onClose={() => setOpen(false)}
        onSubmit={onSignUp}
      />

      <AppFooter link="sign-in" />
    </Box>
  );
};

SignUpPage.propTypes = {
  firebase: PropTypes.object.isRequired,
  setUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default connect(
  null,
  { setUser: setCurrentUser }
)(withFirebase(withRouter(SignUpPage)));
